import { render, staticRenderFns } from "./PrepaidsCreate.vue?vue&type=template&id=cfbc0d76"
import script from "./PrepaidsCreate.vue?vue&type=script&lang=js"
export * from "./PrepaidsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports